import * as React from 'react';
import {IUser} from "../../functions/Interfaces";

class AddressForm extends React.Component<{ customer: IUser }> {
  public render() {
    return (
      <div>
        <h2>Deine Lieferadresse</h2>
        <p>
          {this.props.customer.firstName} {this.props.customer.lastName}{" "}
        </p>
        <p>{this.props.customer.address}</p>
      </div>
    );
  }
}
export default AddressForm;


// WEBPACK FOOTER //
// ./src/components/checkout/AddressForm.tsx